module.exports = __webpack_public_path__ + "img/competition-nasa-2018.ec0cd272.png";